import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from '../root-route'

/** Вне `shellRoute`: полноэкранные служебные карточки, без шапки — как `login`. */
export const noAccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/no-access',
  component: lazyRouteComponent(() => import('@/pages/no-access'), 'NoAccessPage'),
})

export const noCompaniesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/no-companies',
  component: lazyRouteComponent(() => import('@/pages/no-companies'), 'NoCompaniesPage'),
})
